import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/')({
  loader: async ({ params: { loopId, org } }) => {
    throw redirect({
      to: '/org/$org/loop/$loopId/planner/table',
      params: { org, loopId },
      search: { mode: 'live' },
    });
  },
});
